module.exports = __webpack_public_path__ + "static/media/strokewidth-icon.11d10a39.svg";